// [SPRINT K P1] Categories config — extraction depuis Chat.jsx (ligne 57 historique).
// HORS RANGE LOCK Chat.jsx 2001-2200. Source de vérité unique pour le dropdown
// catégories du chat + autres surfaces (sidebar, landing).

export const CHAT_CATEGORIES = [
  "live",
  "news",
  "mode",
  "beauté",
  "coiffure",
  "marché",
  "tech",
  "sport",
  "culture",
  "business",
  "abidjan_vibes",
];

export default CHAT_CATEGORIES;
